import React, { useEffect, useState } from "react";
import { MEMBER_BASEURL } from "./config/ApiConfig";
import { CardNumberElement, CardCvcElement, CardExpiryElement, useStripe, useElements } from "@stripe/react-stripe-js";

export default function PaymentForm(props) {
  const stripe = useStripe();
  const elements = useElements();

  //const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  //const [succeeded, setSucceeded] = useState(false);

  /* No idea why but needed this block below to prevent console error
     "Can't perform a React state update on an unmounted component"
  */
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
    }
    return () => {
      isMounted = false;
    };
  });

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setProcessing(true);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: {
        name: ev.target.name.value,
      },
    });
    if (error) {
      setError(`Payment failed: ${error.message}`);
      setProcessing(false);
      console.log("[error]", error);
    } else {
      setError(null);
    }

    if (typeof paymentMethod !== "undefined") {
      const caregiverFlowFields = {
        enrollmentType: "caregiver",
        caregiverFirstName: props.currentState.caregiverFirstName.trim(),
        caregiverLastName: props.currentState.caregiverLastName.trim(),
        caregiverEmail: props.currentState.caregiverEmail === "" ? undefined : props.currentState.caregiverEmail.trim(),
        caregiverPhone: props.currentState.caregiverPhone.trim(),
        relationship: props.currentState.caregiverRelationship.trim(),
        firstName: props.currentState.lovedOneFirstName.trim(),
        lastName: props.currentState.lovedOneLastName.trim(),
        birthDay: props.currentState.lovedOneBirthDay.trim(),
        birthMonth: props.currentState.lovedOneBirthMonth.trim(),
        birthYear: props.currentState.lovedOneBirthYear.trim(),
        email: props.currentState.lovedOneEmail === "" ? undefined : props.currentState.lovedOneEmail.trim(),
        phone: props.currentState.lovedOnePhone.trim(),
        zipcode: props.currentState.lovedOneZip.trim(),
        reason: props.currentState.lovedOneReason.trim(),
        inviteCode:
          props.currentState.wizardStep === "signup"
            ? props.currentState.inviteCode === ""
              ? undefined
              : props.currentState.inviteCode.trim()
            : props.currentState.inviteCode2 === ""
            ? undefined
            : props.currentState.inviteCode2.trim(),
        termsAndPrivacyAccepted: props.currentState.termsAndPrivacyAccepted,
      };
      const selfFields = {
        enrollmentType: "member",
        firstName: props.currentState.firstName.trim(),
        lastName: props.currentState.lastName.trim(),
        birthDay: props.currentState.birthDay.trim(),
        birthMonth: props.currentState.birthMonth.trim(),
        birthYear: props.currentState.birthYear.trim(),
        email: props.currentState.email === "" ? undefined : props.currentState.email.trim(),
        phone: props.currentState.phone.trim(),
        zipcode: props.currentState.zip.trim(),
        inviteCode:
          props.currentState.wizardStep === "signup"
            ? props.currentState.inviteCode === ""
              ? undefined
              : props.currentState.inviteCode.trim()
            : props.currentState.inviteCode2 === ""
            ? undefined
            : props.currentState.inviteCode2.trim(),
        termsAndPrivacyAccepted: props.currentState.termsAndPrivacyAccepted,
      };
      const fields = {
        enrollment: props.currentState.caregiverFlow ? caregiverFlowFields : selfFields,
        stripePaymentMethodId: paymentMethod.id,
        cardholderName: paymentMethod.billing_details.name,
      };
      const requestBody = JSON.stringify(fields);
      const requestOptions = {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: requestBody,
      };
      fetch(MEMBER_BASEURL + "/v1/rest/payment", requestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            switch (response.status) {
              case 404:
                console.log("Not found");
                break;
              case 500:
                console.log("Internal server error");
                break;
              case 401:
                console.log("Unauthorized");
                break;
              case 400:
                console.log("Bad request");
                break;
              default:
                console.log("Some error occurred error code = " + response.status);
                break;
            }
            response.json().then((err) => {
              // get errors from error body
              console.log(err);
            });
            throw Error("Payment failed");
          }
        })
        .then((responseData) => {
          if (responseData === true) {
            props.setWizardStep("confirmation");
          } else {
            setError(
              "Payment could not be accepted, please try a different payment card or give us a call to pay over the phone."
            );
          }
          setProcessing(false);
        })
        .catch((error) => {
          console.log(error);
          setError(
            "Payment could not be accepted, please try a different payment card or give us a call to pay over the phone."
          );
          setProcessing(false);
        });
    } else {
      console.log("Payment method error");
      console.log(error);
    }
  };

  const renderForm = () => {
    const options = {
      style: {
        base: {
          fontFamily: "Poppins, sans-serif",
          color: "#4f196f",
          fontSize: "22px",
          fontWeight: "700",
          "::placeholder": {
            color: "rgba(50, 52, 58, 0.4)",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      },
    };
    if (props.currentState.isValidInviteCode) {
      return null;
    }
    return (
      <form onSubmit={handleSubmit}>
        <div className="section wide img light gray apply">
          <div className="memberpod apply2">
            <h2 className="heading-5 lightbg leftheading sub payment">Payment Info</h2>
            <h6 className="subtitle">
              You won’t be charged until after your free trial. Cancel at any time, no questions asked.
            </h6>
            <div className="form-3 payment">
              <div className="formfield threefourths">
                <div className="sr-combo-inputs">
                  <div className="sr-combo-inputs-row">
                    <label htmlFor="name" className="field-label">
                      Full Name on Card
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      autoComplete="cardholder"
                      className="sr-input text-field memberinput w-input"
                      required="required"
                    />
                  </div>

                  <div className="sr-combo-inputs-row">
                    <label htmlFor="cardNumber" className="field-label">
                      Card Number
                    </label>
                    <div className="sr-input text-field memberinput w-input" style={{ paddingTop: "12px" }}>
                      <CardNumberElement id="cardNumber" options={options} />
                    </div>
                  </div>
                  <div className="contact-form-grid-2">
                    <div>
                      <label htmlFor="cardExpiry" className="field-label">
                        Expiration
                      </label>
                      <div className="sr-input text-field memberinput w-input" style={{ paddingTop: "12px" }}>
                        <CardExpiryElement id="cardExpiry" options={options} />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="cardCVC" className="field-label">
                        CVC
                      </label>
                      <div className="sr-input text-field memberinput w-input" style={{ paddingTop: "12px" }}>
                        <CardCvcElement id="cardCVC" options={options} />
                      </div>
                    </div>
                  </div>
                </div>

                {error && <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>}
              </div>
            </div>
            <h6 className="caption">
              After any free trial, you will be charged $150/month on a recurring basis. Your service will continue
              until you cancel. To cancel, call us at{" "}
              <a href="tel:8552129242" onClick={() => (window.onbeforeunload = null)}>
                855 212 9242
              </a>
              .
            </h6>
          </div>
          <div style={{ width: "100%", maxWidth: "978px" }}>
            <div style={{ marginTop: "25px", marginBottom: "25px" }}>
              <button className="btn button-hero sub purple w-button" style={{ width: "100%" }} disabled={processing}>
                <span style={{ display: processing ? "none" : "block" }}>Submit</span>
                <svg
                  style={{ display: processing ? "block" : "none" }}
                  className="spinner"
                  version="1.1"
                  id="L9"
                  x="0px"
                  y="0px"
                  viewBox="0 0 100 100"
                  enableBackground="new 0 0 0 0"
                >
                  <path
                    fill="#fff"
                    d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                  >
                    <animateTransform
                      attributeName="transform"
                      attributeType="XML"
                      type="rotate"
                      dur="1s"
                      from="0 50 50"
                      to="360 50 50"
                      repeatCount="indefinite"
                    />
                  </path>
                </svg>
              </button>
            </div>
            <div style={{ textAlign: "center" }}>
              <p className="phoneBottomText">Prefer to pay over the phone? Give us a call.</p>
              <p>
                <a href="tel:8552129242" className="telBottom">
                  855 212 9242
                </a>
              </p>
            </div>
          </div>
        </div>
      </form>
    );
  };

  return (
    <div className="checkout-form">
      <div className="sr-payment-form">
        <div className="sr-form-row" />
        {renderForm()}
      </div>
    </div>
  );
}
